import hatsApi from '@/services/hatsApi'

export default {
  attachMediaToReservationLine (params) {
    return hatsApi().post('/operational/reservation-line-media', params)
  },
  getCollection (filter) {
    return hatsApi().get(`/operational/reservation-line-media?filter=${JSON.stringify(filter)}`)
  },
  downloadMedia (id) {
    return hatsApi().get(`/operational/reservation-line-media/download/${id}`, {'responseType': 'blob'})
  },
  deleteMedia (id) {
    return hatsApi().delete(`/operational/reservation-line-media/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/ReservationLineMedia.js